module.exports = __webpack_public_path__ + "media/bootstrap-icons/square-half-4b6309d3.svg";